export default "__VITE_ASSET__CPY$q9JM__"